import { SVGProps } from 'react';

export const SvgOrders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M2.5 5.00008L5 1.66675H15L17.5 5.00008M2.5 5.00008V16.6667C2.5 17.1088 2.67559 17.5327 2.98816 17.8453C3.30072 18.1578 3.72464 18.3334 4.16667 18.3334H15.8333C16.2754 18.3334 16.6993 18.1578 17.0118 17.8453C17.3244 17.5327 17.5 17.1088 17.5 16.6667V5.00008M2.5 5.00008H17.5M13.3333 8.33341C13.3333 9.21747 12.9821 10.0653 12.357 10.6904C11.7319 11.3156 10.8841 11.6667 10 11.6667C9.11595 11.6667 8.2681 11.3156 7.64298 10.6904C7.01786 10.0653 6.66667 9.21747 6.66667 8.33341"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
